import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const countdownTimerTool: Tool = {
  id: "countdown-timer",
  name: () => m.cd_tool_name(),
  description: () => m.cd_tool_description(),
  icon: "⏳",
  basePath: "/countdown-timer",
  status: "stable",
  tags: ["everyday", "time", "countdown", "countdown-timer"],
};
